import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import Onboarding from '../../screens/Onboarding';
import { onboardingScreens } from '../../screens/Onboarding/constants';
import SecurityTOTP from '../../screens/SecurityTOTP';
import { securityTOTPScreens } from '../../screens/SecurityTOTP/constants';
import NotFound from '../../screens/NotFound';

const LoginRouter = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/`}>
        <Redirect to={`${path}/signup`} />
      </Route>
      <Route exact path={`${path}/signup`}>
        <Onboarding screen={onboardingScreens.SIGNUP} />
      </Route>
      <Route exact path={`${path}/signup/confirm-email`}>
        <Onboarding screen={onboardingScreens.CONFIRM_EMAIL} />
      </Route>
      <Route exact path={`${path}/signup/phone-number`}>
        <Onboarding screen={onboardingScreens.ADD_PHONE_NUMBER} />
      </Route>
      <Route exact path={`${path}/signup/confirm-phone-number`}>
        <Onboarding screen={onboardingScreens.CONFIRM_PHONE_NUMBER} />
      </Route>
      <Route exact path={`${path}/signup/personal-information`}>
        <Onboarding screen={onboardingScreens.ADD_PERSONAL_INFO} />
      </Route>
      <Route exact path={`${path}/signup/additional-details`}>
        <Onboarding screen={onboardingScreens.ADDITIONAL_PERSONAL_DETAILS} />
      </Route>
      <Route exact path={`${path}/signup/address-information`}>
        <Onboarding screen={onboardingScreens.ADD_PHYSICAL_ADDRESS} />
      </Route>
      <Route exact path={`${path}/signup/mailing-address`}>
        <Onboarding screen={onboardingScreens.ADD_MAILING_ADDRESS} />
      </Route>
      <Route exact path={`${path}/login`}>
        <Onboarding screen={onboardingScreens.LOGIN} />
      </Route>
      <Route exact path={`${path}/login/2fa`}>
        <Onboarding screen={onboardingScreens.TFA} />
      </Route>
      <Route exact path={`${path}/totp`}>
        <SecurityTOTP screen={securityTOTPScreens.MAIN} />
      </Route>
      <Route exact path={`${path}/totp-secret`}>
        <SecurityTOTP screen={securityTOTPScreens.SCAN} />
      </Route>
      <Route exact path={`${path}/totp-secret-save`}>
        <SecurityTOTP screen={securityTOTPScreens.SAVE} />
      </Route>
      <Route exact path={`${path}/totp-verify`}>
        <SecurityTOTP screen={securityTOTPScreens.VERIFY} />
      </Route>
      <Route exact path={`${path}/totp-warning-reset-secret`}>
        <SecurityTOTP screen={securityTOTPScreens.RESET_WARNING} />
      </Route>
      <Route exact path={`${path}/totp-reset-secret`}>
        <SecurityTOTP screen={securityTOTPScreens.RESET_TFA} />
      </Route>
      <Route exact path={`${path}/reset-password`}>
        <Onboarding screen={onboardingScreens.RESET_PASSWORD_REQUEST} />
      </Route>
      <Route exact path={`${path}/reset-password/sent`}>
        <Onboarding screen={onboardingScreens.CONFIRM_RESET_PASSWORD_EMAIL} />
      </Route>
      <Route exact path={`${path}/reset-password/change/:resetKey`}>
        <Onboarding screen={onboardingScreens.CREATE_NEW_PASSWORD} />
      </Route>
      <Route exact path={`${path}/reset-password/confirm-phone-number`}>
        <Onboarding screen={onboardingScreens.TFA} />
      </Route>
      <Route path={`${path}/*`}>
        <NotFound />
      </Route>
    </Switch>
  );
};

export default LoginRouter;
